import React, { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress, Snackbar } from "@material-ui/core";
import ENDPOINT from "../../context/EndPoint";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Toast } from "react-bootstrap";
import { useDispatch } from "react-redux";
import SecurityHeaders from "../../context/SecurityHeaders";
import { Grid, Paper, Typography, TextField, MenuItem, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';

const EditCourseOverview = ({ id, batchid, course_id }) => {
  const dispatch = useDispatch();

  const { user } = useContext(AuthContext);

  const params = useParams();

  const courseid = params.course_id;

  useEffect(() => {
    getCourse();
  }, []);

  const [ctitle, setctitle] = useState(null);
  const [cduration, setcduration] = useState(null);
  const [cdescription, setcdescription] = useState(null);
  const [crating, setcrating] = useState(null);
  const [cratings, setcratings] = useState(null);
  const [cprice, setcprice] = useState(null);
  const [cutoff, setcutoff] = useState(null);
  const [offerends, setofferends] = useState(null);
  const [seatsleft, setseatsleft] = useState(null);
  const [nextbatch, setnextbatch] = useState(null);
  const [coursedata, setcoursedata] = useState(null);
  const [cstatus, setcstatus] = useState(null);
  const [promourl, setpromourl] = useState(null);
  const [coverurl, setcoverurl] = useState(null);
  const [courseurl, setcourseurl] = useState(null);

  const [status, setstatus] = useState("pending");
  const [addstatus, setaddstatus] = useState(false);
  const [snackbar, setsnackbar] = useState(false);
  const [snackbarMessage, setsnackbarMessage] = useState(null);
  const [desktopCover, setDesktopCover] = useState(null);
  const [mobileCover, setMobileCover] = useState(null);

  const [desktopPreview, setDesktopPreview] = useState(null);
const [mobilePreview, setMobilePreview] = useState(null);

  const updateCourse = async (e) => {
    dispatch({ type: "LOADING" });

    try {
      e.preventDefault();
      const formData = new FormData();

      formData.append("session", user.SessionId);
      formData.append("course_id", courseid);
      formData.append("course_status", cstatus);
      formData.append("course_title", ctitle);
      formData.append("description", cdescription);
      formData.append("course_price", cprice);
      formData.append("cutoff_price", cutoff);
      formData.append("offer_ends", offerends);
      formData.append("seats_left", seatsleft);
      formData.append("next_batch", nextbatch);
      formData.append("rating", crating);
      formData.append("ratings", cratings);
      formData.append("duration", cduration);
      formData.append("course_url", courseurl ?? "");
      formData.append("course_promo_url", promourl ?? "");
   if (desktopCover instanceof File) {
  formData.append("course_cover_url", desktopCover);
}

if (mobileCover instanceof File) {
  formData.append("course_mobile_cover_url", mobileCover);
}
      const res = await axios.post(
        ENDPOINT + "admin-edit-overview.php",
        formData,
        // {
        //   // headers: {
        //   //   "content-type": "multipart/form-data",
        //   // },
        // },
      );

      if (res) {
        if (res.data.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          settoasttitle("Update successful");
          settoastmessage("Changes saved successfully");
          settoast(true);
        } else {
          dispatch({
            type: "ERROR",
            payload: res.data.message || "Failed to update course",
          });
          settoasttitle("Something went wrong!");
          settoastmessage("Please try again...");
          settoast(true);
        }
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: error.message || "An error occurred while updating course",
      });
      settoasttitle("Error");
      settoastmessage(error.message || "An error occurred");
      settoast(true);
    }
  };

  const getCourse = async () => {
    dispatch({ type: "LOADING" });
    const data = new FormData();
    data.append("course_id", courseid);

    try {
      const response = await axios.post(
        `${ENDPOINT}admin-get-course-details.php`,
        data,
        SecurityHeaders,
      );

      const result = response.data;

      if (result.status === "success") {
        dispatch({ type: "DONE_LOADING" });
        setcoursedata(result.data[0]);
        const data = result.data[0];
        setcrating(data.rating);
        setctitle(data.course_title);
        setcdescription(data.course_description);
        setcratings(data.ratings);
        setnextbatch(data.next_batch);
        setseatsleft(data.seats_left);
        setcduration(data.course_duration);
        setcprice(data.course_price);
        setcutoff(data.course_cutoff_price);
        setofferends(data.offer_ends);
        setpromourl(data.course_promo_url);
        setcourseurl(data.course_url);
        setcoverurl(data.course_cover_url);
        setDesktopPreview(data.course_cover_url);   // 👈 ADD
setMobilePreview(data.course_mobile_cover_url); // if available
      } else {
        dispatch({
          type: "ERROR",
          payload: result.message || "Failed to fetch course details",
        });
        setaddstatus(false);
        setsnackbarMessage("Something went wrong");
        setsnackbar(true);
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload:
          error.message || "An error occurred while fetching course details",
      });
      setsnackbarMessage("Failed to fetch course details: " + error.message);
      setsnackbar(true);
    }
  };

  const options = ["Option 1", "Option 2"];
  const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  const [toast, settoast] = useState(false);
  const [toasttitle, settoasttitle] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);

  return (
    <>
      <div className="position-fixed bottom-60 left-0 w-100 justify-center">
        <Toast
          className="bg-warning"
          onClose={() => settoast(false)}
          show={toast}
          delay={4000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">{toasttitle}</strong>
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
      </div>
      {coursedata ? (
        <Paper elevation={3} sx={{ p: 3, maxWidth: 1100, margin: "32px auto" }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
            <Typography variant="h5" gutterBottom={false}>
              Edit Course Overview
            </Typography>
            <IconButton onClick={() => window.history.back()} edge="end">
              <ArrowBackIcon />
            </IconButton>
          </Box>
          <form method="POST" className="w-100">
            <Grid container spacing={2}>
              <Grid item xs={12} md={10}>
                <TextField
                  label="Title"
                  fullWidth
                  value={ctitle || ""}
                  onChange={(e) => setctitle(e.target.value)}
                  inputProps={{ maxLength: 100 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Status"
                  select
                  fullWidth
                  value={cstatus || ""}
                  onChange={(e) => setcstatus(e.target.value)}
                  margin="normal"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="paused">Paused</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Description"
                  fullWidth
                  value={cdescription || ""}
                  onChange={(e) => setcdescription(e.target.value)}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Course URL"
                  fullWidth
                  value={courseurl || ""}
                  onChange={(e) => setcourseurl(e.target.value)}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Promo URL"
                  fullWidth
                  value={promourl || ""}
                  onChange={(e) => setpromourl(e.target.value)}
                  margin="normal"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2">
                  Desktop Cover Image (Local)
                </Typography>
                {desktopPreview && (
  <img
    src={desktopPreview}
    alt="Desktop Preview"
    style={{ width: "120px", marginTop: 10, borderRadius: 8 }}
  />
)}
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setDesktopCover(file);
                    if (file) {
                      setDesktopPreview(URL.createObjectURL(file)); // preview
                    }
                  }}
                />
               
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2">
                  Mobile Cover Image (Local)
                </Typography>
                {mobilePreview && (
  <img
    src={mobilePreview}
    alt="Mobile Preview"
    style={{ width: "100%", marginTop: 10, borderRadius: 8 }}
  />
)}
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setMobileCover(file);
                    if (file) {
                      setMobilePreview(URL.createObjectURL(file));
                    }
                  }}
                />
               
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label={`Actual Price (${cprice ? cprice + 0.18 * cprice : ""})`}
                  fullWidth
                  value={cprice || ""}
                  onChange={(e) => setcprice(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Cutoff Price"
                  fullWidth
                  value={cutoff || ""}
                  onChange={(e) => setcutoff(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Offer Ends"
                  fullWidth
                  value={offerends || ""}
                  onChange={(e) => setofferends(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Seats Left"
                  fullWidth
                  value={seatsleft || ""}
                  onChange={(e) => setseatsleft(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label={`Next Batch (${nextbatch || ""})`}
                  type="date"
                  fullWidth
                  value={nextbatch || ""}
                  onChange={(e) => setnextbatch(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Duration"
                  fullWidth
                  value={cduration || ""}
                  onChange={(e) => setcduration(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Rating"
                  fullWidth
                  value={crating || ""}
                  onChange={(e) => setcrating(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Ratings"
                  fullWidth
                  value={cratings || ""}
                  onChange={(e) => setcratings(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
            </Grid>
            <Snackbar
              open={snackbar}
              autoHideDuration={6000}
              onClose={() => setsnackbar(false)}
              message={snackbarMessage}
            />
            <button
              type="submit"
              className="btn btn-primary w-100 mt-4"
              onClick={updateCourse}
              style={{ fontWeight: 600, fontSize: 18 }}
            >
              {addstatus ? (
                <CircularProgress className="text-white" size={20} />
              ) : (
                ""
              )}{" "}
              Save Changes
            </button>
          </form>
        </Paper>
      ) : (
        <div className="text-center py-5">
          <CircularProgress />
          <div>Loading course data...</div>
        </div>
      )}
    </>
  );
};

export default EditCourseOverview;
